import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Group, Text } from "@mantine/core";
import { loadMarkerIcon } from "@mapka/maplibre-gl-sdk";
import { skipToken, useQuery } from "@tanstack/react-query";
import { memo, useEffect, useMemo } from "react";
import { selectedItemBg, layerItemHeight } from "../../utils/style.js";
const ICON_SIZE = 16;
const DEFAULT_COLOR = "#3FB1CE";
function getMarkerLabel(marker) {
    const content = marker.popup?.content;
    if (content?.title)
        return content.title;
    if (marker.id)
        return marker.id;
    return marker.lngLat.join(", ");
}
function colorSvg(svg, color, size) {
    const doc = new DOMParser().parseFromString(svg, "image/svg+xml");
    const root = doc.querySelector("svg");
    if (!root)
        return null;
    root.setAttribute("fill", color);
    root.setAttribute("width", size.toString());
    root.setAttribute("height", size.toString());
    return root.outerHTML;
}
export const MarkerListItem = memo(({ marker, selected, onClick }) => {
    const color = marker.color ?? DEFAULT_COLOR;
    const label = getMarkerLabel(marker);
    const iconId = marker.icon;
    const { data: svg, error } = useQuery({
        queryKey: ["markerIcon", iconId],
        queryFn: iconId ? async () => loadMarkerIcon(iconId) : skipToken,
        staleTime: Infinity,
        retry: 1,
    });
    useEffect(() => {
        if (error) {
            window.logger.warn({ icon: iconId, error }, "Failed to load marker icon");
        }
    }, [error, iconId]);
    const coloredSvg = useMemo(() => (svg ? colorSvg(svg, color, ICON_SIZE) : null), [svg, color]);
    return (_jsxs(Group, { gap: "xs", h: layerItemHeight, px: 8, wrap: "nowrap", onClick: onClick, bg: selectedItemBg(selected), style: { cursor: "pointer" }, children: [coloredSvg
                ? (_jsx(Flex, { w: ICON_SIZE, h: ICON_SIZE, align: "center", justify: "center", "aria-hidden": "true", title: iconId, dangerouslySetInnerHTML: { __html: coloredSvg } }))
                : (_jsx(Box, { w: ICON_SIZE, h: ICON_SIZE, bg: color, style: { borderRadius: "50%", flexShrink: 0 } })), _jsx(Text, { fz: 14, truncate: true, children: label })] }));
});
MarkerListItem.displayName = "MarkerListItem";
